<template>
	<dashboard-promo :filters="{ keys: computeFilters }"></dashboard-promo>
</template>
<script>
	import { ref, inject, onMounted, computed } from "vue";
	import dashboardPromo from "@/components/webComponents/widget/dashboardPromo/dashboardPromo.vue";

	export default {
		components: {
			dashboardPromo
		},
		props: {
			json: {
				type: String,
				default: undefined
			},
			pageFilters: {
				type: String,
				default: "{}"
			}
		},
		setup(props, context) {
			const $json = inject("$json");

			const filter = ref([]);
			const globalFilters = ref({});

			if ($json.packed(props.json)) {
				filter.value = JSON.parse($json.unpack(props.json));
			} else {
				filter.value = JSON.parse(props.json || "[]");
			}

			if ($json.packed(props.pageFilters)) {
				globalFilters.value = JSON.parse($json.unpack(props.pageFilters));
			} else {
				globalFilters.value = JSON.parse(props.pageFilters || "{}");
			}

			const computeFilters = computed(() => {
				if (filter.value.length > 0) {
					return filter.value;
				} else if (globalFilters.value.AssignmentsFilter.length > 0) {
					return globalFilters.value.AssignmentsFilter;
				} else {
					return globalFilters.value.Parent?.AssignmentsFilter || [];
				}
			});

			return {
				computeFilters
			};
		}
	};
</script>
